import React, { Component } from 'react';
import SelectInput, { findItem } from 'Components/forms/select-input/SelectInput.jsx';
import Label from 'Components/forms/label/Label';
import TextField from 'Components/forms/text-field/TextField';
import DropDownList from 'Components/DropDownList/DropDownList';
import Checkbox from 'Components/forms/checkbox/Checkbox.jsx';
import RadioButton from 'Components/forms/radio-button/RadioButton.jsx';
import ImageModal from 'Components/ImageModal/ImageModal';
import ImageWizardAccordian from 'Components/ImageWizardAcordian/ImageWizardAccordian';
import NestedFieldSelector from 'Components/NestedFieldSelector/NestedFieldSelector';
import DisplayPanel from 'Components/DisplayPanel/DisplayPanel';
import ReviewScreen from 'Components/ReviewScreen/ReviewScreen';
import MerchantMessage from 'Components/MerchantMessage/MerchantMessage';
import PropTypes from 'prop-types';
import DaysLeftCalendar from 'Components/DaysLeftCalendar/DaysLeftCalendar';
import './ActionIssuerComponents.scss';
import AutoCompleteDropdown from 'Components/AutoCompleteDropdown/AutoCompleteDropdown';
import * as ActionConstants from '../IssuerActions/ActionConstants.js';
import Questionnaire from '../Questionnaire/Questionnaire';
import TextInput from 'Components/forms/text-input/TextInput';
import CurrencySingleInput from 'Components/forms/currency-single-input';
import SingleDateInput from 'Components/forms/SingleDateInput/SingleDateInput';
import {
  __OPTIONAL__,__DROPDOWN__, __DEFAULT_CURRENCY_LIST__, __MERCHANT_MESSAGE__, __USD__, __MSGBOX__, __REVIEW_SCREEN__,
  __COMMENTS__, __DISCOVER_BRAND_NAME__, __CHECKBOX__, __PUSH__, __POP__, __TEXT__, __DROPDOWNLIST__,
  __WIZARD_ACCORD__, __CURRENCY__, __NESTED_FIELD_SELECTOR__, __DISPLAY_PANEL__, __DAYS_LEFT_CALENDAR__,
  __AUTO_COMPLETE_DROPDOWN_COMBO__, __VISA_QUESTIONNAIRE__, __UPLOAD_DOCUMENT__, __DATE__,__RADIO_BUTTON__,__MASTERCARD_STAGE_CONFIG_ID__,__MASTERCARD_2700_REASON_CODE__,
  UNDERSCORE_DATE, PCF_ACTION_CODE, OTHER_PCF_VIOLATION_CODE
} from './ActionIssuerConstants';
import UploadDocuments from 'Components/UploadDocuments/UploadDocuments';
import ResponseBanner from 'Components/cards/ResponseBanner';
import moment from 'moment';
import { preciseToDecimal } from 'Utils/formatting';
import counterpart from "counterpart";
import FinancialsBanner from 'Components/cards/FinancialsBanner/FinancialsBanner';
import crossIcon from '../../assets/img/cross.png';
import docIcon from '../../assets/img/document.svg';
import { removeInvalidCharacters } from "Utils/validationUtils";
import { debounce, isEmpty } from 'Utils/lodashUtils.js';
import ImagePortal from '../ImagePortal/ImagePortal';
import { COLORS } from "Constants/BIDashboardConstants"

let isPartial = false;
let description = null;
let isFinancialCheckbox = null;
let disableFinancials = false;

class ActionIssuerComponents extends Component {
  constructor(props) {
    super(props);
    this.dropDownIndex = -1;
    this.state = {
      isFirstTimeLoad: true,
      isAcqRespPopulated: false,
      isRespResPopulated: false,      
      inputHeadings: [],
      selectedInput: null,
      selectedInputDropDownList: null,
      length: 0,
      max: props.issuerIndex >= 0 && props.jsonHeadings[props.issuerIndex] !== undefined && props.jsonHeadings[props.issuerIndex].textAreaMaxLength !== undefined ? props.jsonHeadings[props.issuerIndex].textAreaMaxLength : 999,
      className: 'input-text-area valid-input-area',
      textAreaValue: '',
      financialLossExp: '--',
      secondaryOptions: [],
      isOpen: false,
      amountData: {},
      pageList: [
        {
          pageContent: [],
          pageId: 0,
        },
      ],
      canvasSelectedIndex: {},
      selectedAccordianIndex: -1,
      activeRuleCheckBox: false,
      visible: false,
      pageCountMessage: 'Selected Pages',
      pageCount: {},
      selectedItemText: '',
      imageContentsErr: false,
      selectedPage: -1,
      selectedActionIssuerId: 0,
      documentType: '',
      isDocumentAttached: false,
      isDataLoaded: false,
      attachArray: [],
      letterTemplateLength: 0,
      isMerchantMessageAvailable: false,
      userSelectedImageOrder: [],
      selectedCurrency: [],
      showValidationWarning:false,
      maxForAdtnlReviewBox:1000,
      TransaferFundsNowvalues : [
        {
          name: 'Yes',
          id: 'YES',
          isChecked: true,
          isRadioDisabled: false
        },
        {
          name: 'No',
          id: 'NO',
          isChecked: false,
          isRadioDisabled: true
        
        },
      ],
      isCommonCommentsValidationError: true,
    };

    this.attachBindings();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.jsonHeadings && this.props.issuerIndex !== -1 && this.props.jsonHeadings[this.props.issuerIndex]) {
      const dropDownDataColumn = this.props.jsonHeadings[this.props.issuerIndex].dataColumns?.find((dataColumn) => {
        return dataColumn.displayType === __DROPDOWN__;
      });
      if (dropDownDataColumn && this.state.multiSelectList && !this.state.selectedInput) {
        this.state.multiSelectList.forEach(selectionList => {
          if (selectionList.length == 1) {
            this.onSelectionChange(selectionList[0]);
          }
        })

      }
      if (
        this.props.actionViewCode === 'RTI' &&
        this.props.cardBrand === 'VISA' &&
        (this.props.disputeStageName === 'Incoming Pre-Arbitration' ||
          this.props.disputeStageName === 'Incoming Pre-Compliance')
      ) {
        const [adjustFinancialsCheckbox, checkboxIndex] =
          this.financialsCheckboxInfo(
            this.props.jsonHeadings[this.props.issuerIndex]
          );

        if (
          adjustFinancialsCheckbox &&
          isPartial &&
          !this.props.checkBoxStatus[checkboxIndex]
        ) {
          this.toggleCheckbox(checkboxIndex);
          disableFinancials = true;
        }

        const [prevAdjustFinancialsCheckbox, prevCheckboxIndex] =
          this.financialsCheckboxInfo(
            prevProps.jsonHeadings[this.props.issuerIndex]
          );

        if (
          prevAdjustFinancialsCheckbox &&
          !isPartial &&
          this.props.checkBoxStatus[prevCheckboxIndex]
        ) {
          disableFinancials = false;
          this.toggleCheckbox(prevCheckboxIndex);
        }
      }
    }
  }

  componentWillMount() {
    let merchantIndex = this.props.jsonHeadings && this.props.issuerIndex && this.props.jsonHeadings[this.props.issuerIndex].dataColumns?.findIndex((dataColumn) => {
      return dataColumn.displayType == __MERCHANT_MESSAGE__;
    })
    if (merchantIndex != -1) {
      this.setState({
        isMerchantMessageAvailable: this.props.isMerchantMessageAvailable,
      })
    }
    this.setInitialAmount();
    if (this.props.issuerIndex !== undefined && this.props.selectionList !== undefined) {
      let multiSelectList = [];
      multiSelectList[0] = this.props.selectionList;
      if (this.props.responseReasonList && this.props.responseReasonList.length > 0) {
        multiSelectList[1] = this.props.responseReasonList;
      }

      this.setState({
        secondaryOptions: this.props.selectionList !== undefined && this.props.selectionList.length == 0 ? [] : this.props.selectionList,
        selectedInput: this.props.selectedOption,
        length: 0,
        issuerIndex: this.props.issuerIndex,
        checkBoxStatus: this.props.checkBoxStatus,
        isFinancialLossOccured: this.props.isFinancialLossOccured,
        attachArray: this.props.attachArray,
        multiSelectList,
        showQuesCurrency: this.props.showQuesCurrency,
      });

      if(this.isMerchantImageItemSelected(this.props.selectedActionIssuerId)) {
       this.setState({
         documentType: ActionConstants.__MERCHANT_IMAGE_DATA__
       });
      }
      else if(this.isIssuerImageItemSelected(this.props.selectedActionIssuerId)) {
        this.setState({
          documentType: ActionConstants.__ISSUER_IMAGE_DATA__
        });
      }
    }
    if (this.props.selectedActionIssuerId) {
      this.setState({
        selectedActionIssuerId: this.props.selectedActionIssuerId,
      });
    }
    if (this.refs.notes == undefined || this.refs.notes.value == '') {
      this.props.onDisableNextStep(true);
    }
    if (this.props.issuerIndex !== undefined && this.props.jsonHeadings !== undefined && this.props.jsonHeadings.length - 1 >= this.props.issuerIndex) {
      const updateIndexMsgBox = this.props.jsonHeadings[this.props.issuerIndex].dataColumns?.findIndex((dataColumn) => {
        return dataColumn.displayType === __MSGBOX__;
      });
      const updateIndexAutoComplete = this.props.jsonHeadings[this.props.issuerIndex].dataColumns?.findIndex((dataColumn) => {
        return dataColumn.displayType === __AUTO_COMPLETE_DROPDOWN_COMBO__;
      });

      if (updateIndexAutoComplete !== -1 && this.state.selectedSearchOption == undefined) {
        this.initializeSelectSearchValue({});
      } if (updateIndexMsgBox !== -1 && this.state.isFinancialLossOccured == undefined && this.props.isFinancialLossOccured == undefined) {
        this.initializeAgreementStatus(false);
      }
    }
    if (this.props.jsonHeadings !== undefined) {
      this.resetWizard(this.props, __REVIEW_SCREEN__);
      this.setState({
        jsonHeadings: [...this.props.jsonHeadings]
      })
    }
  }

  financialsCheckboxInfo(data) {
    if (data.dataColumns) {
      const financialsCheckbox = data.dataColumns?.filter(
        (dataColumn) =>
          dataColumn.displayType === __CHECKBOX__ &&
          dataColumn.name === 'Adjust Financials'
      );
      const checkboxIndex = data.dataColumns
        .filter((column) => column.displayType === __CHECKBOX__)
        .findIndex((checkbox) => checkbox.name === 'Adjust Financials');
      return [financialsCheckbox, checkboxIndex];
    }
    return [null, null];
  }

  setInitialAmount() {
    if (this.props.showQuesCurrency) {
      this.setState({
        showQuesCurrency: this.props.showQuesCurrency
      });
    }
    let selectedCurrency = [];
    let representmentAmount = [];
    representmentAmount = this.props.representmentAmount ? this.props.representmentAmount : representmentAmount;
    selectedCurrency[0] = this.props.merchantCurrencyCode;
    let isGoodFaithSelected = (this.props.selectionList.length == 1 && this.props.selectionList[0].text.toLowerCase() == "create good faith request") || (this.props.selectedOption && this.props.selectedOption[0] && this.props.selectedOption[0].text.toLowerCase() == "create good faith request") ? true : false;
    if (!isGoodFaithSelected && this.props.disputeAmount && this.props.actionViewCode == PCF_ACTION_CODE && this.props.issuerIndex == 0)
      representmentAmount[0] = preciseToDecimal(this.props.disputeAmount, 2);
    this.setState({
      representmentAmount,
      selectedCurrency,
    });
  }

  showTransferFundsNow() {
     const obj=this.state.TransaferFundsNowvalues.map((values)=>{
      return(
        <div>
        <RadioButton
        id={values.id}
        label={values.name}
        onChange={this.handleOnChange}
        isChecked={values.isChecked}
        disabled = {values.isRadioDisabled}
        />  
        </div>
      );
    });
    return obj;
  }

  handleOnChange(e) {
    const id=e.target.id
    const newTransferFundValues =this.state.TransaferFundsNowvalues.map((values) =>
    {
      const newTransferFundValue =Object.assign({}, values);
      newTransferFundValue.isChecked=false;
      if (newTransferFundValue.id === id) {
        newTransferFundValue.isChecked = true;
      }
      return newTransferFundValue;

    });
    this.setState({
      TransaferFundsNowvalues: [...newTransferFundValues],
    });
    
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== undefined) {
      this.resetActionPaneValues(nextProps);
    }
    if (this.props.selectionList !== nextProps.selectionList) {
      this.setState({
        secondaryOptions: nextProps.selectionList
      });
    }
    if (this.props.balanceAmount !== nextProps.balanceAmount) {
      const updateIndex = nextProps.jsonHeadings.findIndex((jsonObject) => {
        return jsonObject.reviewScreenKey === 'financialAdjustment';
      });
      if (updateIndex !== -1) {
        this.props.onDisableNextStep(parseFloat(nextProps.balanceAmount) !== 0.00);
      }
    }
    if (this.props.jsonHeadings !== undefined && JSON.stringify(this.props.jsonHeadings) !== JSON.stringify(nextProps.jsonHeadings)) {
      this.setState({
        jsonHeadings: [...nextProps.jsonHeadings]
      })
    }
    if (this.props.showQuesCurrency !== nextProps.showQuesCurrency) {
      this.setState({
        showQuesCurrency: nextProps.showQuesCurrency,
      })
    }
    nextProps.representmentAmount && this.props.representmentAmount != nextProps.representmentAmount && this.setRepresentmentAmount(nextProps);
    let isGoodFaithSelected = (nextProps.selectionList.length == 1 && nextProps.selectionList[0].text.toLowerCase() == "create good faith request") || (nextProps.selectedOption && nextProps.selectedOption[0] && nextProps.selectedOption[0].text.toLowerCase() == "create good faith request") ? true : false;
    if (!isGoodFaithSelected && nextProps.actionViewCode == PCF_ACTION_CODE && nextProps.issuerIndex == 0) {
      let representmentAmount = nextProps.representmentAmount ? nextProps.representmentAmount : [];
      if (nextProps.selectedOption && nextProps.selectedOption[0] && nextProps.selectedOption[0].text.toLowerCase().indexOf("partial".toLowerCase()) == -1) {
        representmentAmount[0] = preciseToDecimal(nextProps.disputeAmount, 2);
      }
      this.setState({
        representmentAmount,
      });
    }
    if (!this.props.asyncLoading !== nextProps.asyncLoading) {
      if(this.isMerchantImageItemSelected(nextProps.selectedActionIssuerId)) {
        this.setState({
          documentType: ActionConstants.__MERCHANT_IMAGE_DATA__
        }, () => { this.resetImageWizardStatus() });
      }
      else if(this.isIssuerImageItemSelected(nextProps.selectedActionIssuerId)) {
        this.setState({
          documentType: ActionConstants.__ISSUER_IMAGE_DATA__
        }, () => { this.resetImageWizardStatus() });
      }
    }
    if (this.state.isFirstTimeLoad && this.props.jsonHeadings[this.state.issuerIndex] && this.props.jsonHeadings[this.state.issuerIndex].reviewScreenKey === ActionConstants.__REPRESENTMENT_QUESTION_KEY__ && this.props.cardBrandCode === ActionConstants.__MASTERCARD_BRAND_CODE__ && this.props.actionViewCode === 'RTI' && this.props.disputeStageName === 'Chargeback' && this.state.isAcqRespPopulated && this.state.isRespResPopulated) {
      var attachDocIndex = this.getAttachDocIndex();
      this.setState({ 
          isFirstTimeLoad: false,
      });
      this.props.attachDocumentPage(this.state.issuerIndex, __PUSH__,attachDocIndex, this.props.issuerActionData);
  }
  }

  setRepresentmentAmount(nextProps) {
    let representmentAmount = nextProps.representmentAmount;
    if (nextProps.actionViewCode == PCF_ACTION_CODE && nextProps.issuerIndex == 0 && nextProps.representmentAmount.length > 0) {
      let selectedCurrency = [];
      selectedCurrency[0] = nextProps.merchantCurrencyCode;
      this.setState({
        selectedCurrency,
      });
    }
    if (nextProps.representmentAmount.length > 0) {
      this.setState({
        representmentAmount,
      });
    }
  }

  componentDidMount() {
    let selectedCurrency = [];
    selectedCurrency[0] = this.props.merchantCurrencyCode;
    this.setState({
      selectedCurrency
    })
  }
  attachBindings() {

    this.isVisible = this.isVisible.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.handleFinancialLossExp = this.handleFinancialLossExp.bind(this);
    this.charCount = this.charCount.bind(this);
    this.toggleThisAccordion = this.toggleThisAccordion.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.updateSelectedPages = this.updateSelectedPages.bind(this);
    this.selectImagePage = this.selectImagePage.bind(this);
    this.closeImageModal = this.closeImageModal.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.openSelectedPageInModal = this.openSelectedPageInModal.bind(this);
    this.updatePageListArray = this.updatePageListArray.bind(this);
    this.selectAllPagesFromArray = this.selectAllPagesFromArray.bind(this);
    this.deselectAllPages = this.deselectAllPages.bind(this);
    this.acceptFinancialLoss = this.acceptFinancialLoss.bind(this);
    this.initializeAgreementStatus = this.initializeAgreementStatus.bind(this);
    this.validateCheckBox = this.validateCheckBox.bind(this);
    this.handleSearchDropdownSelection = this.handleSearchDropdownSelection.bind(this);
    this.initializeSelectSearchValue = this.initializeSelectSearchValue.bind(this);
    this.validateAttachedDocument = this.validateAttachedDocument.bind(this);
    this.resetWizard = this.resetWizard.bind(this);
    this.resetImageWizardStatus = this.resetImageWizardStatus.bind(this);
    this.toggleImageAccordion = this.toggleImageAccordion.bind(this);
    this.setSelectedCurrency = this.setSelectedCurrency.bind(this);
    this.onChangeCurrency = this.onChangeCurrency.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.validateAmounts = this.validateAmounts.bind(this);
    this.validateDates = this.validateDates.bind(this);
    this.validateAndCompareDates = this.validateAndCompareDates.bind(this);
    this.setInitialAmount = this.setInitialAmount.bind(this);
    this.setRepresentmentAmount = this.setRepresentmentAmount.bind(this);
    this.setInputTextData = this.setInputTextData.bind(this);
    this.showTransferFundsNow=this.showTransferFundsNow.bind(this);
    this.handleOnChange=this.handleOnChange.bind(this);
    this.formControlGroup=this.formControlGroup.bind(this);
    this.hideReturnToPDRCheckBox = this.hideReturnToPDRCheckBox.bind(this);
  }

  resetImageWizardStatus() {
    let pageListArray = this.props.caseDocuments[this.state.documentType]?.pageListArray ? this.props.caseDocuments[this.state.documentType].pageListArray : this.props.caseDocuments.pageListArray;
    var imageWizardStatusList = [];
    pageListArray.forEach((page) => {
      imageWizardStatusList = imageWizardStatusList.concat(true);
    });
    this.setState({
      imageWizardStatusList,
    })
  }
  resetWizard(props, displayType) {
    if (props && props.issuerIndex !== -1 && props.jsonHeadings[props.issuerIndex]) {
      let datacolumns = props.jsonHeadings[props.issuerIndex].dataColumns;
      var wizardStatusList = [];
      datacolumns.forEach(dataColumn => {
        if (dataColumn.displayType === displayType) {
          let columnKey = dataColumn.columnKey;
          let wizStatus = {
            columnKey,
            status: true,
          }
          wizardStatusList = wizardStatusList.concat(wizStatus);
        }
      });
      this.setState({
        wizardStatusList,
      })
    }
  }

  isIssuerImageItemSelected(selectedActionId) {
    return selectedActionId == ActionConstants.__RESPOND_TO_ISSUER_ISSUER_DOCS_ID__;
  }
  isMerchantImageItemSelected(selectedActionId) {
    return selectedActionId == ActionConstants.__UNABLETO_FULFILL_MERCH_DOCS_ID__ || selectedActionId == ActionConstants.__NOTIFY_AND_REQUEST_MERCH_DOCS_ID__ || selectedActionId == ActionConstants.__RESPOND_TO_ISSUER_MERCH_DOCS_ID__ || selectedActionId == ActionConstants.__UNABLE_TO_DEFEND_PURSUE_MERCH_DOCS_ID__ || selectedActionId == ActionConstants.__REQUEST_ADDITIONAL_INFO_MERCH_DOCS_ID__ || selectedActionId == ActionConstants.__WRITEOFF_GOODWILL_MERCH_DOCS_ID__;
  }

  

  /**
   * This page is responsible for resetting the page data on intialisation
   * @param {contains nextprops data} nextProps
   */
  resetActionPaneValues(nextProps) {
    let merchantIndex = nextProps.issuerIndex && nextProps.jsonHeadings[nextProps.issuerIndex].dataColumns?.findIndex((dataColumn) => {
      return dataColumn.displayType == __MERCHANT_MESSAGE__;
    })
    if (merchantIndex != -1) {
      this.setState({
        isMerchantMessageAvailable: nextProps.isMerchantMessageAvailable
      })
    } else {
      this.setState({ isMerchantMessageAvailable: false });
    }
    if ((nextProps.issuerIndex !== undefined && this.props.issuerIndex !== nextProps.issuerIndex) || (this.props.selectedActionId !== undefined && this.props.selectedActionId !== nextProps.selectedActionId)) {
      if (this.props.selectedActionIssuerId !== nextProps.selectedActionIssuerId) {
        this.setState({
          selectedActionIssuerId: nextProps.selectedActionIssuerId,
          isOpen: false,
          attachArray: nextProps.attachArray,
          selectedAccordianIndex: -1,
        });
      }
     
      if (nextProps.jsonHeadings !== undefined) {
        this.resetWizard(nextProps, __REVIEW_SCREEN__);
      }
      // refresh text area
      if (this.refs.notes !== undefined) { this.refs.notes.value = ''; }
      // refresh text area and select input
      let multiSelectList = [];
      multiSelectList[0] = nextProps.selectionList;
      if (nextProps.responseReasonList && nextProps.responseReasonList.length > 0) {
        multiSelectList[1] = nextProps.responseReasonList;
      }
      this.setState({
        secondaryOptions: nextProps.selectionList !== undefined && nextProps.selectionList.length == 0 ? [] : nextProps.selectionList,
        selectedInput: nextProps.selectedOption,
        length: 0,
        className: 'input-text-area valid-input-area',
        issuerIndex: nextProps.issuerIndex,
        max: nextProps.jsonHeadings !== undefined && nextProps.jsonHeadings[nextProps.issuerIndex] !== undefined && nextProps.jsonHeadings[nextProps.issuerIndex].textAreaMaxLength !== undefined ? nextProps.jsonHeadings[nextProps.issuerIndex].textAreaMaxLength : 500,
        isFinancialLossOccured: nextProps.isFinancialLossOccured,
        attachArray: nextProps.attachArray,
        multiSelectList
      });
      if (nextProps.issuerIndex !== undefined && nextProps.jsonHeadings !== undefined && nextProps.jsonHeadings.length - 1 >= nextProps.issuerIndex) {
        const updateIndexMsgBox = nextProps.jsonHeadings[nextProps.issuerIndex].dataColumns?.findIndex((dataColumn) => {
          return dataColumn.displayType === __MSGBOX__;
        });
        const updateIndexAutoComplete = nextProps.jsonHeadings[nextProps.issuerIndex].dataColumns?.findIndex((dataColumn) => {
          return dataColumn.displayType === __AUTO_COMPLETE_DROPDOWN_COMBO__;
        });
        //Initalize messgeBox and search options
        if (updateIndexAutoComplete !== -1 && this.state.selectedSearchOption == undefined) {
          this.initializeSelectSearchValue({});
        } else if (updateIndexAutoComplete == -1) {
          this.initializeSelectSearchValue(undefined);
        }
        if (updateIndexMsgBox !== -1 && this.state.isFinancialLossOccured == undefined && nextProps.isFinancialLossOccured == undefined) {
          this.initializeAgreementStatus(false);
        } else if (updateIndexMsgBox == -1) {
          this.initializeAgreementStatus(undefined);
        }
      }
    }

    if (nextProps.checkBoxStatus !== this.props.checkBoxStatus) {
      this.setState({
        checkBoxStatus: nextProps.checkBoxStatus,
        issuerIndex: nextProps.issuerIndex,
      });
    }
    if (nextProps.textAreaValue !== this.props.textAreaValue) {
      this.setState({
        textAreaValue: nextProps.textAreaValue,
        issuerIndex: nextProps.issuerIndex,
        length: nextProps.length,
        showCharCount: nextProps.showCharCount,
      });
    }
    if (((!this.props.selectionList && nextProps.selectionList) || this.props.selectionList && nextProps.selectionList && this.props.selectionList !== nextProps.selectionList) || (nextProps.responseReasonList && this.props.responseReasonList != nextProps.responseReasonList)) {
      let multiSelectList = [];
      multiSelectList[0] = nextProps.selectionList;
      if (nextProps.responseReasonList && nextProps.responseReasonList.length > 0) {
        multiSelectList[1] = nextProps.responseReasonList;
      }
      this.setState({
        secondaryOptions: nextProps.selectionList,
        multiSelectList,
      });
    }
    if (this.props.selectedOption != nextProps.selectedOption) {
      this.setState({
        selectedInput: nextProps.selectedOption,
      });
    }
  }


  // This method is responsible for selecting the image of a file.
  selectImagePage = (index) => {
   let selectedPage = 
    this.props.caseDocuments[this.state.documentType]?.imageToolKitData ?
    this.props.caseDocuments[this.state.documentType].imageToolKitData[this.state.selectedPage] :
    this.props.caseDocuments.imageToolKitData[this.state.selectedPage]
   if (index >= 0 && index < selectedPage.length) {
     this.setState({
       canvasSelectedIndex: { [this.state.selectedPage]: index },
     });
   }
  };

  // This method is used for closing the modal of images.
  closeImageModal = (e) => {
    this.setState({
      visible: false,
    });
  };

  // This method handles dropdownlist changes
  handleSelectionChange(selectedItem) {
    let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
    if (textArea && textArea.disputeType) {
      textArea = textArea.disputeType === this.props.reasonCodeCategoryDesc ? textArea : undefined;
    }
    let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
    if (this.props.acquirerCode !== 'EMD' || this.props.actionViewCode !== 'RID'){
       this.props.onEndEdit(selectedItem, this.state.textAreaValue, this.props.caseNumber, this.state.textAreaValue.length, this.state.checkBoxStatus, this.state.isFinancialLossOccured, this.state.selectedSearchOption, isTextRequired, this.state.representmentAmount, this.state.selectedCurrency, this.state.financialLossExp);
    }
    this.validateTextAreaAndAmount(isTextRequired, this.state.representmentAmount, selectedItem, this.state.textAreaValue, this.props.date);
    if (selectedItem) {
      this.setState({ selectedInputDropDownList: selectedItem });
    }
  }

  // This method updates image pages selection one by one.
  updateSelectedPages(selectedPages, selectedFileIndex) {


    if (selectedFileIndex == undefined) {
      selectedFileIndex = this.state.selectedPage;
    }
    const updateIndex = selectedPages.findIndex((caseObject) => {
      return caseObject.isSelected === true;
    });
    const pageCount = selectedPages.length;

    const orderOfSelectedPagesClone = [...this.props.caseDocuments[this.state.documentType].orderOfSelectedPages];
    const latestSelectedpages = orderOfSelectedPagesClone.filter(page => {
      return page.pageNumber !== selectedFileIndex;
    });

    let pageToBeUpdated = latestSelectedpages.concat({
      imageData: selectedPages,
      pageNumber: selectedFileIndex,
    });

    let imageOrderSeq = [];
    pageToBeUpdated.forEach(page => {
      page.imageData.forEach(image => {
        imageOrderSeq = imageOrderSeq.concat({
          pageId: image.pageId,
          addedWhen: image.addedWhen,
          pageNumber: page.pageNumber,
        });
      });
    });

    imageOrderSeq = imageOrderSeq.sort((a, b) => (a.addedWhen > b.addedWhen) ? 1 : -1);
    this.props.updateSelectedCaseDocuments(this.state.documentType, pageToBeUpdated, imageOrderSeq, selectedPages, selectedFileIndex, pageCount, false);
  }

  // This method is used for selecting all pages in image selector.
  selectAllPagesFromArray(selectedFileIndex) {
    let pageListArray = this.props.caseDocuments[this.state.documentType].pageListArray ? this.props.caseDocuments[this.state.documentType].pageListArray : this.props.caseDocuments.pageListArray;
    const allSelectedPages = pageListArray[selectedFileIndex].map((page) => {
        return { pageId: page.pageId, pageContent: page.pageContent, isSelected: true, addedWhen: Date.now() + page.pageId, docId: page.docId, documentName : page.documentName, documentType:page.documentType };
    });

    const pageCount = allSelectedPages.length;
    if (pageListArray[selectedFileIndex].length == allSelectedPages.length) {

      const orderOfSelectedPagesClone = [...this.props.caseDocuments[this.state.documentType].orderOfSelectedPages];
      const latestSelectedpages = orderOfSelectedPagesClone.filter(page => {
        return page.pageNumber !== selectedFileIndex;
      });

      const pageToBeUpdated = latestSelectedpages.concat({
        imageData: allSelectedPages,
        pageNumber: selectedFileIndex,
      });
      let imageOrderSeq = [];
      pageToBeUpdated.forEach(page => {
        page.imageData.forEach(image => {
          imageOrderSeq = imageOrderSeq.concat({
            pageId: image.pageId,
            addedWhen: image.addedWhen,
            pageNumber: page.pageNumber,
          });
        });
      });

      imageOrderSeq = imageOrderSeq.sort((a, b) => (a.addedWhen > b.addedWhen) ? 1 : -1)

      this.props.updateSelectedCaseDocuments(this.state.documentType, pageToBeUpdated, imageOrderSeq, allSelectedPages, selectedFileIndex, pageCount, true);
    } else {
      this.updateSelectedPages(allSelectedPages, selectedFileIndex);
    }
  }

  deselectAllPages(selectedFileIndex) {
    this.updateSelectedPages([], selectedFileIndex);
  }

  // This method is used for toggling the image wizard accordian.
  toggleThisAccordion = (id) => {
    var wizardStatusList = Object.assign([], this.state.wizardStatusList);
    let index = wizardStatusList && wizardStatusList.findIndex((wizStatus) => wizStatus.columnKey === id);
    if (index !== -1) {
      let wizardObj = Object.assign({}, wizardStatusList[index]);
      wizardObj.status = !wizardObj.status;
      wizardStatusList[index] = wizardObj;
      this.setState({
        wizardStatusList
      })
    }

  }
  toggleImageAccordion = (index) => {
    var imageWizardStatusList = Object.assign([], this.state.imageWizardStatusList);
    if (index !== -1) {
      imageWizardStatusList[index] = !imageWizardStatusList[index];
      this.setState({
        imageWizardStatusList,
        selectedPage: index
      })
    }

  }
  /**
  * This method is used for updating the char count in the text area.
  * @param {contains event of text area} event
  */

  charCount = (value) => {
    this.setState({
      length: value.length,
      textAreaValue: value
    }) /**Added for 241 latency issue */

    let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
    if (textArea && textArea.disputeType) {
      textArea = textArea.disputeType === this.props.reasonCodeCategoryDesc ? textArea : undefined;
    }
    let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
    if (value.length > 0) {
      const validationFlag = this.validateTextAreaspecialChar(value, textArea);
      if (!validationFlag) {
        return;
      }
    }
    if (this.maxLength(document.getElementById('textArea'))) {
      if (this.props.selectedOption !== undefined && this.props.selectedOption !== null && this.props.selectedOption[0] !== '- Select Description -') { this.props.onDisableNextStep(false); }
      this.setState({
        length: value.length,
      });
      if (value.length > this.state.max) {
        this.props.onDisableNextStep(true);
        this.setState({ className: 'input-text-area error-input-area' });
      } else { this.setState({ className: 'input-text-area valid-input-area' }); }
      this.props.onEndEdit((this.state.secondaryOptions.length > 0 && this.state.selectedInput == null) ? undefined : this.state.selectedInput, value, this.props.caseNumber, value.length, this.state.checkBoxStatus, this.state.isFinancialLossOccured, this.state.selectedSearchOption, isTextRequired, this.state.representmentAmount, this.state.selectedCurrency, this.state.financialLossExp);
      this.validateTextAreaAndAmount(isTextRequired, this.state.representmentAmount, this.state.selectedInput, value, this.props.date);
    }
    if (isTextRequired && (value.length == 0 || !value.replace(/\s/g, '').length)) {
      this.props.onDisableNextStep(true);
      this.setState({ className: 'input-text-area error-input-area' });
    } else if (this.state.selectedInput && this.state.selectedInput.length > 0 && (this.state.selectedInput[0].text.toLowerCase().indexOf('attach document') !== -1 || (this.props.disputeStageName === 'Retrieval Request' && this.props.cardBrand === __DISCOVER_BRAND_NAME__))) {
      let attachDocIndex = this.getAttachDocIndex();
      if (attachDocIndex !== -1) {
        !this.state.checkBoxStatus[attachDocIndex] ? this.props.onDisableNextStep(true) : this.props.onDisableNextStep(false);
      }
    }    
  };

  handleFinancialLossExp = (value) => {
    this.setState({
      length: value.length,
      financialLossExp: value,
    });


    this.props.onEndEdit(this.state.selectedInput == undefined ? null : this.state.selectedInput, this.state.textAreaValue, this.props.caseNumber, this.state.length, this.state.checkBoxStatus, this.state.isFinancialLossOccured, this.state.selectedSearchOption, false, this.state.representmentAmount, this.state.selectedCurrency, value);

    if (value.length > this.state.max) {
      this.props.onDisableNextStep(true);
    }

  }

  // This method is used for restricting the user to write in text area to max count.
  maxLength(el) {
    if (!('maxLength' in el)) {
      const max = el.attributes.maxLength.value;
      el.onkeypress = function () {
        if (this.value.length >= max) return false;
      };
    }
    return true;
  }

  // This method is responsible for select input changes
  onSelectionChange(option) {
    if (!this.state.selectedInput || (this.state.selectedInput && this.state.selectedInput.findIndex(selectedOpt => selectedOpt && selectedOpt.value == option) == -1)) {
      let multiSelectList = Object.assign([], this.state.multiSelectList);
      let dropDownIndex = -1;
      let selectedOption = null;

      if (option) {
        for (let i = 0; i < multiSelectList.length; i++) {
          if (multiSelectList[i].findIndex((item) => option.value == undefined ? item.value === option : item.value == option.value) > -1) {
            selectedOption = multiSelectList[i].find((item) => option.value == undefined ? item.value === option : item.value == option.value);
            dropDownIndex = i;
            break;
          }
        }
        let isFinancialLossOccured = this.state.isFinancialLossOccured;
        let financialLossExp = this.state.financialLossExp;
        if (selectedOption && selectedOption.value && selectedOption.value === 'C135') {
          isFinancialLossOccured = false;
          financialLossExp = '--';
        }
        var attachDocIndex = this.getAttachDocIndex();
        let selectedOptionArrayLength = 0;
        let resetData = false;
        this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.map(dataColumn => {
          if (dataColumn.displayType === __DROPDOWN__) {
            if (dataColumn.resetDataList && dataColumn.resetDataList.findIndex((item) => item === selectedOption.text.trim().toLowerCase()) !== -1) {
              resetData = true;
              selectedOptionArrayLength += 1;
            }
            else if (dataColumn.selectedItem && dataColumn.selectedItem.findIndex((item) => item === selectedOption.text.trim().toLowerCase()) !== -1) {
              selectedOptionArrayLength += 1;
            }
          }
        });

        let selectedOptionArray = new Array(selectedOptionArrayLength > 0 ? selectedOptionArrayLength : multiSelectList.length);
        if (this.state.selectedInput && this.state.selectedInput.length > 0) {
          for (let j = 0; j < selectedOptionArray.length; j++) {
            if (this.state.selectedInput[j]) {
              selectedOptionArray[j] = this.state.selectedInput[j];
            }
          }
        }
        selectedOptionArray[dropDownIndex] = selectedOption;
        if (selectedOption) {
          this.validateAttachedDocument(attachDocIndex, selectedOptionArray);
        }
        let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
        if (textArea && textArea.disputeType) {
          textArea = textArea.disputeType === this.props.reasonCodeCategoryDesc ? textArea : undefined;
        }
        let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
        if (selectedOption !== undefined && selectedOption !== '- Select Description -' && this.state.length > 0) { this.props.onDisableNextStep(false); }
        if (resetData && option == OTHER_PCF_VIOLATION_CODE) {
          this.props.resetTextAndDate(this.props.date, {});
          this.props.updateNextButtonStatus(true);
        }
        else if (resetData) {
          let selectedCurrency = [];
          this.props.setActionPanelJsonData(this.props.issuerProps);
          selectedCurrency[0] = this.props.merchantCurrencyCode;
          this.setState({
            textAreaValue: "",
            checkBoxStatus: [],
            isFinancialLossOccured: undefined,
            representmentAmount: undefined,
            selectedCurrency
          });
          for (let i = 1; i < selectedOptionArray.length; i++) {
            selectedOptionArray[i] = undefined;
          }
          this.setState({ selectedInput: selectedOptionArray });
          this.props.resetTextAndDate();
          this.props.onEndEdit(selectedOptionArray, "", this.props.caseNumber, 0, [], false, undefined, isTextRequired, undefined, selectedCurrency, financialLossExp);
        } else {
          if (this.state.textAreaValue.length > 0) {
            const validationFlag = this.validateTextAreaspecialChar(this.state.textAreaValue, textArea);
            if (!validationFlag) {
              return;
            }
          }
          this.props.onEndEdit(selectedOptionArray, this.state.textAreaValue, this.props.caseNumber, this.state.length, this.state.checkBoxStatus, isFinancialLossOccured, this.state.selectedSearchOption, isTextRequired, this.state.representmentAmount, this.state.selectedCurrency, financialLossExp);
          this.validateTextAreaAndAmount(isTextRequired, this.state.representmentAmount, selectedOptionArray, this.state.textAreaValue, this.props.date);
           
          }
      }
    }
  }

  getAttachDocIndex() {
    var attachIndex = -1;
    var attachDocIndex = -1;
    var dataColumns = this.props.jsonHeadings[this.state.issuerIndex].dataColumns;
    dataColumns.forEach(col => {
      if (col.displayType === __CHECKBOX__) {
        attachIndex++;
        if (col.description === 'Attach Documents') {
          attachDocIndex = attachIndex;
        }
      }
    });
    return attachDocIndex;
  }

  validateAttachedDocument(attachDocIndex, selectedOption) {
    if (attachDocIndex !== -1 && !this.state.checkBoxStatus[attachDocIndex] && selectedOption[0] && ((selectedOption[0].text.toLowerCase().indexOf('attach document') !== -1 || (selectedOption[0].text.toLowerCase().indexOf('attach document') !== -1 && this.state.selectedInput && this.state.selectedInput[0].value !== selectedOption[0].value)))) {
      this.props.attachDocumentPage(this.state.issuerIndex, __PUSH__, attachDocIndex, this.props.issuerActionData);
    }
    else if (attachDocIndex !== -1 && this.state.checkBoxStatus[attachDocIndex] && selectedOption[0] && (this.state.selectedInput && (this.state.selectedInput[0].text.toLowerCase().indexOf('attach document') !== -1 && selectedOption[0].text.toLowerCase().indexOf('attach document') === -1))) {
      this.props.attachDocumentPage(this.state.issuerIndex, __POP__, attachDocIndex, this.props.issuerActionData);
    } else if (attachDocIndex !== -1 && !this.state.checkBoxStatus[attachDocIndex] && selectedOption && selectedOption[0] && this.props.disputeStageName === 'Retrieval Request' && this.props.cardBrand === __DISCOVER_BRAND_NAME__) {
      this.props.attachDocumentPage(this.state.issuerIndex, __PUSH__, attachDocIndex, this.props.issuerActionData);
    }
    this.setState({ selectedInput: selectedOption });
  }

  /**
  * This method is responsible to set the agreement status when user clicks on  checkbox
  */
  acceptFinancialLoss() {
    const agreementStatus = this.state.isFinancialLossOccured == undefined ? false : this.state.isFinancialLossOccured;
    const finLossExp = agreementStatus ? '--' : '';
    this.setState({
      isFinancialLossOccured: !agreementStatus,
      financialLossExp: finLossExp,
    });
    isFinancialCheckbox = !agreementStatus;
    this.props.acceptFinancialLoss(!agreementStatus);
    let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
    if (textArea && textArea.disputeType) {
      textArea = textArea.disputeType === this.props.reasonCodeCategoryDesc ? textArea : undefined;
    }
    let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
    this.props.onEndEdit(this.state.selectedInput == undefined ? null : this.state.selectedInput,
      this.state.textAreaValue, this.props.caseNumber, this.state.length, this.state.checkBoxStatus,
      !agreementStatus, this.state.selectedSearchOption, isTextRequired, this.state.representmentAmount,
      this.state.selectedCurrency, finLossExp);
    this.validateTextAreaAndAmount(isTextRequired, this.state.representmentAmount, this.state.selectedInput, this.state.textAreaValue, this.props.date);

  }

  /**
  * This method is used for toggle and set checkbox data to the state of particular page
  * @param {index of the checkbox if multiple checkbox present on same page is checkbox count is 1 then by default its value is 0} attachIndex
  */
  toggleCheckbox(attachIndex, checkBoxId) {
    if(checkBoxId == "Prevent Merchant Notification") {
      let status = !this.state.checkBoxStatus[attachIndex];
      this.props.skipNotifyMerchant(status, attachIndex)
      document.getElementById("ActionPane").scrollIntoView({behavior:"smooth", block: "start", inline:"start"});
      return;
    }
    if(checkBoxId == "Return to PDR If No Merchant Response Received") {
      let status = !this.state.checkBoxStatus[attachIndex];
      this.props.updateCheckBoxStatus(status, attachIndex);
      this.props.settingReturnToPDRFlag(status);
      return;
    }
    
    if ((this.props.jsonHeadings[this.state.issuerIndex].description === 'Questionnaire' && ((this.state.selectedInput && (this.state.selectedInput[0].text.toLowerCase().indexOf('attach document') !== -1 || this.state.selectedInput[0].text.toLowerCase().indexOf('fulfill retrieval request') !== -1))))) {
      this.state.checkBoxStatus[attachIndex] ? this.props.onDisableNextStep(true) : this.props.onDisableNextStep(false);
    }
    if (this.props.jsonHeadings[0].reviewScreenKey === 'closeCaseReason') {
      this.props.checkBoxFlag(false);
    }
    const issuerIndex = this.props.issuerIndex;
    if ((this.state.checkBoxStatus[attachIndex] !== undefined && !this.state.checkBoxStatus[attachIndex]) || (this.state.checkBoxStatus[attachIndex] == undefined)) {
      this.props.setActionData(this.state.textAreaValue, this.props.caseNumber, this.state.length, this.state.selectedInput, true, this.state.isFinancialLossOccured, this.state.representmentAmount, this.state.selectedCurrency, this.state.financialLossExp);
      this.props.attachDocumentPage(issuerIndex, __PUSH__, attachIndex, this.props.issuerActionData);
    } else {
      this.props.setActionData(this.state.textAreaValue, this.props.caseNumber, this.state.length, this.state.selectedInput, false, this.state.isFinancialLossOccured, this.state.representmentAmount, this.state.selectedCurrency, this.state.financialLossExp);
      this.props.attachDocumentPage(issuerIndex, __POP__, attachIndex, this.props.issuerActionData);
    }
    if (this.props.selectedActionIssuerId == 4) {
      this.props.fetchMerchantDocumentFlag(!this.state.isDocumentAttached);
      this.setState({
        isDocumentAttached: !this.state.isDocumentAttached,
      });
    }
    if (this.state.selectedInput && (this.state.selectedInput[0] && this.state.selectedInput[0].text.toLowerCase().indexOf('attach document') !== -1 || (this.props.disputeStageName === 'Retrieval Request' && this.props.cardBrand === __DISCOVER_BRAND_NAME__))) {
      let attachDocIndex = this.getAttachDocIndex();
      if (attachDocIndex !== -1) {
        !this.state.checkBoxStatus[attachDocIndex] ? this.props.onDisableNextStep(true) : this.props.onDisableNextStep(false);
      }
    }
  }
  handleSingleDateChange = (id, value) => {
    let key = id + UNDERSCORE_DATE;
    let date = {...this.props.date};
    date[key] = value;

    let isDateLimitExceed = false;
    isDateLimitExceed = this.validateAndCompareDates(isDateLimitExceed, date);
    if (!isDateLimitExceed) {
      this.props.setInputTextAndDate(date, this.props.inputText);
      let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
      if (textArea && textArea.disputeType) {
        textArea = textArea.disputeType === this.props.reasonCodeCategoryDesc ? textArea : undefined;
      }
      let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
      this.validateTextAreaAndAmount(isTextRequired, this.state.representmentAmount, this.state.selectedInput, this.state.textAreaValue, date);
    }
  }

  validateAndCompareDates(isDateLimitExceed, dates) {
    let dateIndex = -1;
    let dateDescriptions = [];
    this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.map(dataColumn => {
      if (dataColumn.displayType === __DATE__) {
        dateIndex += 1;
        dateDescriptions[dateIndex] = dataColumn.description;
        if (dataColumn && (dataColumn.greaterThanDateIndex >= 0 && dataColumn.greaterThanDateIndex != undefined && dateIndex != dataColumn.greaterThanDateIndex && dates[dataColumn.greaterThanDateIndex + UNDERSCORE_DATE] && dates[dateIndex + UNDERSCORE_DATE])) {
          if (moment(dates[dateIndex + UNDERSCORE_DATE]).isBefore(dates[dataColumn.greaterThanDateIndex + UNDERSCORE_DATE])) {
            isDateLimitExceed = true;
            this.props.updateNextButtonStatus(true);
            this.setState({
              isDateLimitExceed,
              dateBannerDescription: `${dateDescriptions[dateIndex]} should be greater than ${dateDescriptions[dataColumn.greaterThanDateIndex]}`
            });
          }
        }
      }
    });
    return isDateLimitExceed;
  }

  /**
  * This method is used for opening the selected page in the modal.
  * @param {selected Image Index} canvasSelectedIndex
  */
  openSelectedPageInModal(canvasSelectedIndex, id) {
    this.setState({
      visible: true,
      selectedPage: id,
      canvasSelectedIndex: { [id]: canvasSelectedIndex },
    });
  }
  
  /**
   * This method is responsible for updating the page list of image on the basis of operations
   * @param {Contains image data array base64 } imageToolKitData
   * @param {selected index of image} canvasSelectedIndex
   */
  updatePageListArray(imageToolKitData, canvasSelectedIndex) {
    if (canvasSelectedIndex !== undefined) {
      this.setState({
        canvasSelectedIndex: { [this.state.selectedPage]: canvasSelectedIndex },
      });
    }
    this.props.updatePageListArray(imageToolKitData, this.state.documentType, this.state.selectedPage);
  }

  initializeAgreementStatus(isFinancialLossOccured) {
    this.setState({
      isFinancialLossOccured,
    });
  }

  initializeSelectSearchValue(selectedSearchOption) {
    this.setState({
      selectedSearchOption,
    });
  }

  validateCheckBox(jsonHeadings, checkBoxIndex) {
    let attachType = Array.isArray(jsonHeadings.attachType) ? jsonHeadings.attachType[checkBoxIndex] : Array.isArray(jsonHeadings.secondaryAttachType) ? jsonHeadings.secondaryAttachType[checkBoxIndex] : undefined;
    if (attachType) {
      if (attachType == 'all') {
        return true;
      } 
      if (this.state.attachArray.findIndex((item) => (item.attachType === attachType)) !== -1) {
        return true;
      }
    }
    return false;
  }

  hideReturnToPDRCheckBox(dataColumn, acquirerCode) {
    const excludedAcquirerCodes = ['HPYPD', 'GPNPD']; 
    return !(excludedAcquirerCodes.includes(acquirerCode) && (dataColumn.name === 'Return to PDR If No Merchant Response Received'));
  }


  // method to handle search drop down selection
  handleSearchDropdownSelection(searchValue) {
    let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
    if (textArea && textArea.disputeType) {
      textArea = textArea.disputeType === this.props.reasonCodeCategoryDesc ? textArea : undefined;
    }
    let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
    this.props.onEndEdit(this.state.selectedInput, this.state.textAreaValue, this.props.caseNumber, this.state.textAreaValue.length, this.state.checkBoxStatus, this.state.isFinancialLossOccured, searchValue, isTextRequired, this.state.representmentAmount, this.state.selectedCurrency, this.state.financialLossExp);
    this.validateTextAreaAndAmount(isTextRequired, this.state.representmentAmount, this.state.selectedInput, this.state.textAreaValue, this.props.date);

    if (searchValue) {
      this.setState({ selectedSearchOption: searchValue });
    }
  }

  setSelectedCurrency(selectedCurrency, id) {
    let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
    let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
    let selectedCurrencyList = [];
    selectedCurrencyList[id] = selectedCurrency;
    this.setState({
      selectedCurrency: selectedCurrencyList,
    })
    this.props.onEndEdit(this.state.selectedInput, this.state.textAreaValue, this.props.caseNumber, this.state.textAreaValue.length, this.state.checkBoxStatus, this.state.isFinancialLossOccured, this.state.selectedSearchOption, isTextRequired, this.state.representmentAmount, selectedCurrencyList, this.state.financialLossExp);
    this.validateTextAreaAndAmount(isTextRequired, this.state.representmentAmount, this.state.selectedInput, this.state.textAreaValue, this.props.date);

  }

  isVisible(dataColumn) {

    if (dataColumn.id === 'creditDatePCF') {
      return this.state.selectedInput && this.state.selectedInput[1] && dataColumn.bindWithValue === this.state.selectedInput[1].value;
    }
    else if (dataColumn.id === 'financialLossExp') {
      return Boolean(this.state.isFinancialLossOccured) && this.state.selectedInput && this.state.selectedInput[1] && !Boolean(dataColumn.bindWithValue === this.state.selectedInput[1].value);
    } else if (dataColumn.id === 'isfinancialLoss') {
      return this.state.selectedInput && this.state.selectedInput[1] && !Boolean(dataColumn.bindWithValue === this.state.selectedInput[1].value);
    }
    else {
      return true;
    }
  }

  onChangeCurrency(value, id) {
    const jsonHeadingsCopy = [...this.state.jsonHeadings];
    let disputeAmount = parseFloat(this.props.disputeAmount);
    value = value == undefined || value == "" || value < 0 ? 0 : value;
    value = Number.isNaN(value) ? 0 : value;
    jsonHeadingsCopy[this.state.issuerIndex].dataColumns?.forEach(dataColumn => {
      if (dataColumn.displayType === __CURRENCY__ && dataColumn?.validate) {
          if(!value && dataColumn?.errorMsg) {
            dataColumn.errorMsg = '';
          } else {
            const errMsg = dataColumn.validate(value)
            if(!!errMsg) {
              dataColumn.errorMsg = errMsg;
            }
            else {
              dataColumn.errorMsg = '';
            }
          }
          
      }
    });
    this.setState({
      disputeAmount,
      jsonHeadings: jsonHeadingsCopy,
    });
    let isAcceptance = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.filter(column=>{return column.name === "Acceptance Amount" ?  true : false});
    if (isAcceptance.length == 1) {
      if (value >= disputeAmount) {
        this.setState({
          isLimitExceed: true,
        })
        this.props.updateNextButtonStatus(true);
      }
      else {
        let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
        let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
        let representmentAmount = [];
        representmentAmount[id] = value;
        this.setState({ representmentAmount,
          isLimitExceed: false,
        });

        this.props.onEndEdit(this.state.selectedInput, this.state.textAreaValue, this.props.caseNumber, this.state.textAreaValue.length, this.state.checkBoxStatus, this.state.isFinancialLossOccured, this.state.selectedSearchOption, isTextRequired, representmentAmount, this.state.selectedCurrency, this.state.financialLossExp);
        this.validateTextAreaAndAmount(isTextRequired, representmentAmount, this.state.selectedInput, this.state.textAreaValue, this.props.date);
       
      }
    } else {
      let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
      let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
      let representmentAmount = [];
      representmentAmount[id] = value;
      this.setState({ representmentAmount });

      this.props.onEndEdit(this.state.selectedInput, this.state.textAreaValue, this.props.caseNumber, this.state.textAreaValue.length, this.state.checkBoxStatus, this.state.isFinancialLossOccured, this.state.selectedSearchOption, isTextRequired, representmentAmount, this.state.selectedCurrency, this.state.financialLossExp);
      this.validateTextAreaAndAmount(isTextRequired, representmentAmount, this.state.selectedInput, this.state.textAreaValue, this.props.date);

    }
  }

  validateTextAreaAndAmount(isTextRequired, representmentAmount, selectedOptionArray, textAreaValue, dates) {
    if ((isTextRequired && textAreaValue && textAreaValue.trim() !== '') || !isTextRequired) {
      this.validateCurrency(representmentAmount, selectedOptionArray, dates);
    }
    /**
     *NOTE : Added this code for Oct Compliance to make 'Financial Loss Explaination' field Mandatory for VISA
     Ref : US245210,US245212
     */
    if (this.props.cardBrandCode === 'VI' && this.props.actionViewCode === 'PCF' && selectedOptionArray && selectedOptionArray.text!=='Internal' && selectedOptionArray.text!=='External') {
      if (this.state.financialLossExp === '--' || this.state.financialLossExp.length == 0 || textAreaValue.length === 0) {
        this.props.updateNextButtonStatus(true);
      }
      if ((isFinancialCheckbox === null || isFinancialCheckbox === false) && textAreaValue.length > 0) {
        this.props.updateNextButtonStatus(false);
      }
    }
  
  }

  validateCurrency(value, selectedOptionArray, dates) {
    let isDisabled = this.validateAmounts(value, selectedOptionArray, dates);
    !isDisabled && this.validateDates(isDisabled, selectedOptionArray, dates);
  }

  validateAmounts(value, selectedOptionArray, dates) {
    let isDisabled = false;
    let currencyIndex = -1;
    let selectedInput = selectedOptionArray ? selectedOptionArray : this.state.selectedInput;
    this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.map(dataColumn => {
      if (dataColumn.displayType === __CURRENCY__) {
        if (dataColumn.selectedItem) {
          dataColumn = selectedInput && this.validateDataColumnWithselectedItem(selectedInput, dataColumn);
          currencyIndex += dataColumn ? 1 : 0;
          if (dataColumn && dataColumn.isRequired && value && (value[currencyIndex] && value[currencyIndex] != 0)) {
            /**find dates */
            if (this.validateAndCompareDates(this.state.isDateLimitExceed, dates))
              this.props.updateNextButtonStatus(!isDisabled);
            else
              this.props.updateNextButtonStatus(isDisabled);
          }
          else if (dataColumn && dataColumn.isRequired && (!value || (value && (!value[currencyIndex] || value[currencyIndex] == 0)))) {
            isDisabled = true;
            this.props.updateNextButtonStatus(isDisabled);
          }
        }
      }
    });
    if (selectedOptionArray && selectedOptionArray[0] && value && value.length == 0 &&
      selectedOptionArray[0].text == 'Accept Partial' && selectedOptionArray[0].responseType == 'Questionnaire') 
      this.props.updateNextButtonStatus(true);
    return isDisabled;
  }

  validateDataColumnWithselectedItem(selectedInput, dataColumn) {
    let isDataColumnDefined = false;
    for (let i = 0; i < selectedInput.length; i++) {
      if (selectedInput && selectedInput[i] && dataColumn.selectedItem.findIndex((item) => item === selectedInput[i].text.trim().toLowerCase()) !== -1 ? dataColumn : undefined) {
        isDataColumnDefined = true;
      }
    }
    dataColumn = isDataColumnDefined ? dataColumn : undefined;
    return dataColumn;
  }

  validateDates(isDisabled, selectedOptionArray, dates) {
    let dateIndex = -1;
    let selectedInput = selectedOptionArray ? selectedOptionArray : this.state.selectedInput;
    this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.map(dataColumn => {
      if (dataColumn.displayType === __DATE__ && dataColumn.selectedItem) {
        dateIndex += 1;
        for (let i = 0; i < selectedInput.length; i++) {
          if (dataColumn) {
            dataColumn = selectedInput[i] ? dataColumn : undefined;
          }
        }
        if (!dataColumn) {
          isDisabled = true;
          this.props.updateNextButtonStatus(isDisabled);
        } else {
          dataColumn = dataColumn.selectedItem && selectedInput && this.validateDataColumnWithselectedItem(selectedInput, dataColumn);
          if (dataColumn && dataColumn.isRequired && dates && dates[dateIndex + UNDERSCORE_DATE]) {

            if (this.validateAndCompareDates(this.state.isDateLimitExceed, dates)) {
              this.props.updateNextButtonStatus(!isDisabled);
            }
            else {
              this.props.updateNextButtonStatus(isDisabled);
            }
          }
          else if (dataColumn && dataColumn.isRequired && ((dates && !dates[dateIndex + UNDERSCORE_DATE]) || !dates)) {
            isDisabled = true;
            this.props.updateNextButtonStatus(isDisabled);
          }
        }
      }
    });
  } 
  validateTextAreaspecialChar(value, textArea) {
    if (this.props.acquirerCode === 'MXP' && this.props.actionViewCode === 'RTI') {
      const textAreaRegEx = new RegExp(textArea.regex);
      if (!textAreaRegEx.test(value)) {
        this.setState({
          showValidationWarning: true,
          isCommonCommentsValidationError: false,
          className: 'input-text-area error-input-area'
        });
        this.props.onDisableNextStep(true);
        return false;
      }
    } else if(textArea.description === "Comments") {
      const textAreaRegEx1 = new RegExp(/^[A-Za-z0-9 !#$%&'()*+-.<=>?@{}\r\n]*$/);
      const textAreaRegEx2 = new RegExp(/,(?=[^,]*$)/);
      if (!textAreaRegEx1.test(value) || textAreaRegEx2.test(value)) {
        this.setState({
          showValidationWarning: true,
          isCommonCommentsValidationError: true,
          className: 'input-text-area error-input-area'
        });
        this.props.onDisableNextStep(true);
        return false;
      }
    }
    return true;
  }
  setInputTextData(event, isRequired) {
    let key = event.target.name;
    let inputText = {...this.props.inputText};
    inputText[key] = event.target.value

    if (event == undefined || event.target == undefined) {
      console.error('Invalid event occured', event);
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
      this.props.setInputTextAndDate(this.props.date, inputText);
    }
    if (event.target.value.trim() == "" && isRequired) {
      this.props.updateNextButtonStatus(true);
    } else if (event.target.value.trim() != "" && isRequired) {
      let textArea = this.props.jsonHeadings[this.state.issuerIndex].dataColumns?.find(dataColumn => dataColumn.displayType === __COMMENTS__ && (!dataColumn.stage || dataColumn.stage && dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1));
      let isTextRequired = textArea && textArea.isRequired ? textArea.isRequired : false;
      this.props.onEndEdit(this.state.selectedInput, this.state.textAreaValue, this.props.caseNumber, this.state.textAreaValue.length, this.state.checkBoxStatus, this.state.isFinancialLossOccured, this.state.selectedSearchOption, isTextRequired, this.state.representmentAmount, this.state.selectedCurrency, this.state.financialLossExp);
    }

  }

  closeBanner() {
    this.setState({
      isLimitExceed: false,
      isDateLimitExceed: false,
      showValidationWarning:false,
    });
  }
  
  showDateLimitExceedBanner() {
    if (this.state.isDateLimitExceed) {
      return (
        <div>
        <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title={this.state.dateBannerDescription}
            description=''
            type="warning"
            onClose={this.closeBanner}
            cancelOnly
            cancelButtonText="DISMISS"
          />
          </ImagePortal>
        </div>
      );
    }
  }

  insertAfter = (referenceNode, newNode)=> {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  validationMessagenotAllowedspecialChar() {
    return (
      <div>
      <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={this.state.isCommonCommentsValidationError ? counterpart('globalTranslate.takeAction.validationMsgForComments') : counterpart('globalTranslate.takeAction.validationMsgforSpecialchar')}
          description=""
          type="danger"
          onClose={this.closeBanner}
          cancelOnly
          cancelButtonText="CLOSE"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }
  
  storeLatestStatus = (value,id) =>{
    this.setState({
      totalIdCount:id
    })
    if(this.props.balanceAmount !==0){
      this.props.onDisableNextStep(true);
    }
    if(value > this.props.disputeAmount){
      this.props.onDisableNextStep(true);
    }
  }

  formControlGroup() {
    const jsonHeadings = [...this.state.jsonHeadings];
    const reviewPageDisplayIndex = 0;
    let checkBoxIndex = -1;
    let dropDownIndex = -1;
    let currencyIndex = -1;
    let dateIndex = -1;
    let textIndex = -1;
    let dateKey = dateIndex + UNDERSCORE_DATE;
    let showQuesCurrency = false;
    let showTransferFundsButton=false;
    let finalReviewList;
    let pageListArray = this.props.caseDocuments[this.state.documentType]?.pageListArray ? this.props.caseDocuments[this.state.documentType].pageListArray : this.props.caseDocuments.pageListArray;
    //let value = this.state.disputeAmount ? (Math.round(this.state.disputeAmount * 100) / 100).toFixed(2) + " " + (this.state.selectedCurrency[0] ? this.state.selectedCurrency[0] : __USD__) : this.props.disputeAmount + " " + (this.state.selectedCurrency[0] ? this.state.selectedCurrency[0] : __USD__);
    description = this.state.isLimitExceed ? "The amount accepted must be less than the Dispute Amount." : "";
    if(!this.props.showApiLedgerFlag && this.state.issuerIndex && jsonHeadings[this.state.issuerIndex] && jsonHeadings[this.state.issuerIndex].dataColumns){
      let filteredFinancialObject = jsonHeadings[this.state.issuerIndex].dataColumns?.filter((financialObject)=>{
        return financialObject.columnKey === "financialAdjustment";
      })
      let filteredObjects = jsonHeadings[this.state.issuerIndex].dataColumns?.filter((financialObject)=>{
        return financialObject.columnKey !== "financialAdjustment";
      })
      finalReviewList = [...filteredObjects];
      finalReviewList.splice(3, 0, ...filteredFinancialObject);
    }
    let updatedDataColumnStructure = finalReviewList ? finalReviewList : jsonHeadings && this.state.issuerIndex !== -1 && jsonHeadings[this.state.issuerIndex] !== undefined && jsonHeadings[this.state.issuerIndex].dataColumns !== undefined && jsonHeadings[this.state.issuerIndex].dataColumns;
    return updatedDataColumnStructure && updatedDataColumnStructure.map((dataColumn, dataColumnIndex) => {
      let selectionList = [];

      if (dataColumn.dropDownList !== undefined) {
        selectionList = dataColumn.dropDownList;
        if (this.state.selectedInput == null) {
          this.handleSelectionChange(selectionList[0]);
        }
      } else {
        selectionList = this.state.secondaryOptions;
      }
      if (dataColumn.displayType == __CHECKBOX__) {
        checkBoxIndex += 1;
      } if (dataColumn.displayType == __DATE__) {
        dateIndex += 1;
        dateKey = dateIndex + UNDERSCORE_DATE;
      }
      if (dataColumn.displayType == __CURRENCY__ && (this.state.representmentAmount && (this.state.representmentAmount[0] == 0 || this.state.representmentAmount[0])) && this.props.cardBrand === __DISCOVER_BRAND_NAME__ && this.props.disputeStageName == 'Chargeback') {
        dataColumn.value = this.state.representmentAmount;
        showQuesCurrency = true;
      }

      var wizardStatus;
      if (dataColumn.displayType === __REVIEW_SCREEN__) {
        wizardStatus = this.state.wizardStatusList.find((wizardStatus) => wizardStatus.columnKey == dataColumn.columnKey);
      }

      if (dataColumn.stage) {
        dataColumn = dataColumn.stage.findIndex((item) => item === this.props.disputeStageName) !== -1 ? dataColumn : undefined;
        if (dataColumn && dataColumn.disputeType) {
          dataColumn = dataColumn.disputeType === this.props.reasonCodeCategoryDesc ? dataColumn : undefined;
        }
      }
      if (dataColumn && dataColumn.selectedItem) {
        dataColumn = this.state.selectedInput && this.validateDataColumnWithselectedItem(this.state.selectedInput, dataColumn);
        showQuesCurrency = dataColumn ? true : false;
      }

      if (dataColumn) {
        if (dataColumn.displayType == __CURRENCY__) {
          currencyIndex += 1;
        }
        if (dataColumn.displayType == __DROPDOWN__) {
          dropDownIndex += 1;
          this.dropDownIndex = dropDownIndex;
           if (this.state.isFirstTimeLoad && this.state.multiSelectList[dropDownIndex] && this.state.multiSelectList[dropDownIndex].length > 0 && this.props.cardBrandCode === ActionConstants.__MASTERCARD_BRAND_CODE__ && this.props.actionViewCode === 'RTI' && this.props.disputeStageName === 'Chargeback') {
              if(dataColumn.name === 'Acquirer Response') {
                this.onSelectionChange(this.state.multiSelectList[dropDownIndex].filter((item) => (item.text == "Decline"))[0].value);
                this.setState({
                  isAcqRespPopulated: true,
                });
              } else if (dataColumn.name === 'Response Reason') {
                this.onSelectionChange(this.state.multiSelectList[dropDownIndex][0].value);
                this.setState({
                  isRespResPopulated: true,
                });
              }
            }
          showQuesCurrency = this.state.selectedInput && this.state.selectedInput[dropDownIndex] && this.state.selectedInput[dropDownIndex].text && (this.state.selectedInput[dropDownIndex].text.trim().toLowerCase() == 'partial' || this.state.selectedInput[dropDownIndex].text.trim().toLowerCase() == 'accept partial');
          showTransferFundsButton=this.state.selectedInput && this.state.selectedInput[dropDownIndex] && this.state.selectedInput[dropDownIndex].text && (this.state.selectedInput[dropDownIndex].text.trim().toLowerCase() == 'accept partial') && (this.props.transactioncode == '05' || this.props.transactioncode == '07' );
          isPartial = this.state.selectedInput && this.state.selectedInput[dropDownIndex] && this.state.selectedInput[dropDownIndex].text && (this.state.selectedInput[dropDownIndex].text.trim().toLowerCase() == 'partial' || this.state.selectedInput[dropDownIndex].text.trim().toLowerCase() == 'accept partial');
        }
        return (          
          <div key={dataColumn.key} className={'action-issuer-component-wrapper'} style={{ marginTop: dataColumn.marginTop ? dataColumn.marginTop : 0, marginBottom: dataColumn.marginBottom ? dataColumn.marginBottom : 0 }}  >
            {/** SelectInput is for questionare and Add message and notes to show dropdown */}
            {this.state.showValidationWarning && this.validationMessagenotAllowedspecialChar() }
            {dataColumn.displayType == __DROPDOWN__ && <TextField
              fieldClass="field--fixed-width"
              htmlFor={dataColumn.name}
              labelContent={<span data-radium>
                <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }} htmlFor="user-permissions-list" labelClass="field-label checkbox-group-parent-label">{dataColumn.name}</Label>
              </span>}
              width={dataColumn.width}
            >
              <div style={dataColumn.disabled || (this.state.multiSelectList[dropDownIndex] && this.state.multiSelectList[dropDownIndex].length == 1) ? { marginTop: 11, marginBottom: 11, cursor: 'not-allowed', pointerEvents: 'none' } : { marginTop: 11, marginBottom: 11 }}>
                <SelectInput
                  dataList={this.state.multiSelectList[dropDownIndex] ? this.state.multiSelectList[dropDownIndex] : []}
                  promptText={this.state.multiSelectList[dropDownIndex] && this.state.multiSelectList[dropDownIndex].length > 0 ? '- Select Description -' : '- No Data Found -'}
                  wrapperClass="select-menu__form reports"
                  extraClass="option-box"
                  handleSelection={this.onSelectionChange}
                  selectedItem={this.state.selectedInput && this.state.selectedInput[dropDownIndex] ? this.state.selectedInput[dropDownIndex] : null}
                  isDisabled={dataColumn.disabled ? dataColumn.disabled : this.state.multiSelectList[dropDownIndex] && this.state.multiSelectList[dropDownIndex].length == 1 ? true : false}
                  isReadOnlyGreyDisable={dataColumn.disabled ? dataColumn.disabled : this.state.multiSelectList[dropDownIndex] && this.state.multiSelectList[dropDownIndex].length == 1 ? true : false}
                />
              </div>
            </TextField>}

            {dataColumn.displayType == __DROPDOWNLIST__ && <DropDownList
              dropDownList={selectionList}
              selectedItemText={this.state.selectedInputDropDownList === null  ? selectionList[0].text : this.state.selectedInputDropDownList.text}
              selectDropdownItem={this.handleSelectionChange}
              extraStyle={{ width: dataColumn.width, left: dataColumn.left }}
              wrapperButtonStyle={{ left: dataColumn.left, bottom: this.props.actionViewCode === 'RID' ? dataColumn.bottom :  -15 }}
              actionPositionStyle={{ position: 'relative' }}
              disable={ this.props.actionViewCode === 'RID' ? true :false}

            />}
            {/** Comments is for questionare and Add message and notes */}
            {dataColumn.displayType == __COMMENTS__ && dataColumn.id !== 'ReasonforAdditionalReview' && this.isVisible(dataColumn) && <div style={{ marginTop: dataColumn.marginTop, marginBottom: 11 }}>
              <TextField
                fieldClass="field--fixed-width"
                htmlFor={dataColumn.name}
                labelContent={<span data-radium>
                  <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }}
                    htmlFor="user-permissions-list" labelClass="field-label checkbox-group-parent-label-note">{dataColumn.name}
                    <span style={{ float: 'right', fontSize: 12, fontWeight: 400, color: `${COLORS.oneGp.black}` }}>
                      {this.state.length}/ {this.state.max} </span></Label>
                </span>}
                width={dataColumn.width}
                display="inline-block"
              >

                <div style={{ marginTop: this.props.actionViewCode === 'RID' ? dataColumn.marginTop : 11, marginBottom: 11 }}>
                  <textarea  
                    value={dataColumn.id === 'financialLossExp' ? this.state.financialLossExp : this.state.textAreaValue}
                    ref="notes" 
                    id={dataColumn.id === 'financialLossExp'?"financialLossExp":"textArea"}
                    maxLength={this.state.max}
                    onChange={(event) => { 
                      dataColumn.id === 'financialLossExp' ? 
                      this.handleFinancialLossExp(event.target.value) : 
                      this.charCount(dataColumn.description === "Comments" ? removeInvalidCharacters(event.target.value) : event.target.value)
                    }}
                    style={{ width: dataColumn.width, border: '1px solid #d7dce1' }}
                    className={this.state.className}
                  /></div>
              </TextField>
            </div>}
            {dataColumn.displayType == __COMMENTS__ && dataColumn.id === 'ReasonforAdditionalReview' && this.isVisible(dataColumn) && this.props.merchantMessage.returnToPDRFlag &&<div style={{ marginTop: dataColumn.marginTop, marginBottom: 11 }}>
              <TextField
                fieldClass="field--fixed-width"
                htmlFor={dataColumn.name}
                labelContent={<span data-radium>
                  <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.black}` }}
                    htmlFor="user-permissions-list" labelClass="field-label checkbox-group-parent-label-note">{dataColumn.name}<span style={{color: '#f4364c'}}> * </span>
                    <span style={{ float: 'right', fontSize: 12, fontWeight: 400, color: `${COLORS.oneGp.black}`}}>
                      {this.props.reasonForAdditionalReviewLength}/{this.state.maxForAdtnlReviewBox}</span></Label>
                </span>}
                width={dataColumn.width}
                display="inline-block"
              >

                <div className='text-area-reasonForAdditionalReview'>
                  <textarea 
                    defaultValue={this.props.merchantMessage.reasonForAdditionalReview}
                    id={dataColumn.id}
                    maxLength={this.state.maxForAdtnlReviewBox}
                    onChange={(event) => {  
                      this.props.settingReasonForAdditionalReview(event.target.value)
                    }}
                    style={{ width: dataColumn.width, border: '1px solid #d7dce1' }}
                    className={this.state.className}
                  /></div>
              </TextField>
            </div>}

            {dataColumn.displayType == __WIZARD_ACCORD__ && pageListArray !== undefined && pageListArray.length > 0 && <TextField
              fieldClass="field--fixed-width"
              htmlFor={dataColumn.name}
              labelContent={<span data-radium>
                <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: `${COLORS.oneGp.charcoal}` }} htmlFor="user-permissions-list" labelClass="field-label checkbox-group-parent-label">{dataColumn.name}</Label>
              </span>}
              width={dataColumn.width}
              display="inline-block"
            >

              {pageListArray.map((data, index) => {
                let arePagesSelected = 
                  this.props.caseDocuments[this.state.documentType].pageCount[index] === undefined 
                  || this.props.caseDocuments[this.state.documentType].pageCount[index] === 0;
                return (
                  <ImageWizardAccordian
                    key={index}
                    userSelectedImageOrder={this.props.caseDocuments[this.state.documentType] ? this.props.caseDocuments[this.state.documentType].imageOrderSeq : []}
                    headerText={
                      this.props.caseDocuments.documentTypeNames[index] + " - "+ this.props.caseDocuments.disputeStageNames[index]
                    }
                    docDate={this.props.caseDocuments.docReceivedDates[index]}
                    footerText={this.props.caseDocuments.documentNames[index]}
                    fileSize={this.props.caseDocuments.documentSize[index]}
                    isOpen={this.state.imageWizardStatusList && this.state.imageWizardStatusList[index] ? true : false}
                    toggleAccordion={this.toggleImageAccordion}
                    id={index}
                    enabledButtonIndex={index}
                    contentType={dataColumn.contentType}
                    headerButtonName={ arePagesSelected ? "Select All" : "De-select All" }
                    updatePageSelectionIndexMethod={this.openSelectedPageInModal}
                    updatePageSelectionIndex={this.selectImagePage}
                    headerButtonStyle={{ 
                      width: 120,
                      height: 35,
                      fontWeight: 600,
                      color: '#262aff',
                      background: '#ffffff',
                      border: '1px solid #c4c4c4',
                    }}
                    headerActionMethod={ arePagesSelected ? this.selectAllPagesFromArray : this.deselectAllPages }
                    pageSelectorStyle={{
                      paddingLeft: 25,
                      paddingRight: 'unset',
                      display: 'inline-flex',
                      width: 169,
                    }}
                    pageSelected={arePagesSelected ? `${0} ${this.state.pageCountMessage}` : `${this.props.caseDocuments[this.state.documentType].pageCount[index]} ${this.state.pageCountMessage}`}
                    pageList={data}
                    updateParentSelectedPages={this.updateSelectedPages}
                    canvasSelectedIndex={this.state.canvasSelectedIndex[index]}
                    imageCheckBoxRequired={false}
                    selectedPages={this.props.caseDocuments[this.state.documentType].selectedPages[index]}
                    selectAllFlag={this.props.caseDocuments[this.state.documentType].selectAllFlag[index]}
                    acquirerCode ={this.props.acquirerCode}
                  />);
              },
              )}
            </TextField>}
            {dataColumn.displayType == __WIZARD_ACCORD__ && pageListArray.length === 0 && <div>
              <FinancialsBanner
                  title={counterpart('globalTranslate.takeAction.supportingDocsNeeded')}
                  image={crossIcon}
                  bannerStyle= {{
                    margin: 0,
                    backgroundColor: '#E12619',
                    paddingLeft: '2%',
                    paddingRight: '2%',
                    height: '9.2vh'
                  }}
                />
                <div className='blank-doc'>
                  <img alt="docicon" src={docIcon} />
                  <span>{counterpart('globalTranslate.takeAction.noDocsAttached')}</span>
                </div>
            </div>}
            {this.state.isLimitExceed ? <span className = "highlight-red">
              {
              dataColumn.displayType == __TEXT__ && <div style={{ marginTop: 11, marginBottom: 11, width: dataColumn.width, display: 'flex' }}><TextInput
                label={dataColumn.description}
                name={dataColumn.name}
                value={!isEmpty(this.props.inputText) ? this.props.inputText[dataColumn.name] : undefined}
                type={dataColumn.inputType ? dataColumn.inputType : 'text'}
                width={dataColumn.float ? dataColumn.width - 25 : dataColumn.width}
                extraClass={dataColumn.className ? dataColumn.className : 'text-input-questionnaire '}
                extraStyle={{ fontSize: 12, fontWeight: 500, color: '#595959' }}
                onChange={this.setInputTextData}
                isRequired={dataColumn.isRequired}
                asterikRequired={false}
                disable={dataColumn.disabled ? dataColumn.disabled : false}
              />
              </div>

              }
              {dataColumn.displayType == __CURRENCY__ && showQuesCurrency  && <div style={{
                marginTop: dataColumn.marginTop ? dataColumn.marginTop : 11,
                marginLeft: dataColumn.marginLeft ? dataColumn.marginLeft : 11, width: dataColumn.width
                }}>
                <CurrencySingleInput 
                  currencyCodeDisabled={dataColumn.currencyCodeDisabled} 
                  title={dataColumn.name} 
                  id={currencyIndex} 
                  currencyList={__DEFAULT_CURRENCY_LIST__} 
                  onChange={this.onChangeCurrency} 
                  selectedCurrency={this.state.selectedCurrency && this.state.selectedCurrency[currencyIndex] ? this.state.selectedCurrency[currencyIndex] : dataColumn.isMerchantCurrencyCode && this.props.merchantCurrencyCode ? this.props.merchantCurrencyCode : __USD__} 
                  handleSelectedCurrency={this.setSelectedCurrency} 
                  filterLow={this.state.representmentAmount ? this.state.representmentAmount[currencyIndex] : undefined} 
                  disable={dataColumn.disabled ? dataColumn.disabled : false} 
                  isCurrencyLabel={dataColumn.isCurrencyLabel} 
                  max={dataColumn?.max}
                  validationError={dataColumn?.errorMsg}
                />
              </div>}
              {dataColumn.displayType == __CURRENCY__ && <p className ="exceed-msg">{description}</p>}
            </span>
            :
            <span>
              {
              dataColumn.displayType == __TEXT__ && <div style={{ marginTop: 11, marginBottom: 11, width: dataColumn.width, display: 'flex' }}><TextInput
                label={dataColumn.description}
                name={dataColumn.name}
                value={!isEmpty(this.props.inputText) ? this.props.inputText[dataColumn.name] : undefined}
                type={dataColumn.inputType ? dataColumn.inputType : 'text'}
                width={dataColumn.float ? dataColumn.width - 25 : dataColumn.width}
                extraClass={dataColumn.className ? dataColumn.className : 'text-input-questionnaire'}
                extraStyle={{ fontSize: 12, fontWeight: 500, color: '#595959' }}
                onChange={this.setInputTextData}
                isRequired={dataColumn.isRequired}
                asterikRequired={false}
                disable={dataColumn.disabled ? dataColumn.disabled : false}
              />
              </div>

              }
              {dataColumn.displayType == __CURRENCY__ && showQuesCurrency  && <div style={{
                marginTop: dataColumn.marginTop ? dataColumn.marginTop : 11,
                marginLeft: dataColumn.marginLeft ? dataColumn.marginLeft : 11, width: dataColumn.width
              }}>
                <CurrencySingleInput 
                  currencyCodeDisabled={dataColumn.currencyCodeDisabled} 
                  title={dataColumn.name} 
                  id={currencyIndex} 
                  currencyList={__DEFAULT_CURRENCY_LIST__} 
                  onChange={this.onChangeCurrency} 
                  selectedCurrency={this.state.selectedCurrency && this.state.selectedCurrency[currencyIndex] ? this.state.selectedCurrency[currencyIndex] : dataColumn.isMerchantCurrencyCode && this.props.merchantCurrencyCode ? this.props.merchantCurrencyCode : __USD__} 
                  handleSelectedCurrency={this.setSelectedCurrency} 
                  filterLow={this.state.representmentAmount ? this.state.representmentAmount[currencyIndex] : undefined} 
                  disable={dataColumn.disabled ? dataColumn.disabled : false} 
                  isCurrencyLabel={dataColumn.isCurrencyLabel} 
                  max={dataColumn?.max}
                  validationError={dataColumn?.errorMsg}
                />
              </div>}
            </span>
            }
               {showTransferFundsButton && dataColumn.displayType == __RADIO_BUTTON__ && <div >
              <TextField
              labelContent={dataColumn.description} />
              {this.showTransferFundsNow()}
            </div>
      }
            {
              dataColumn.displayType == __CHECKBOX__ && !dataColumn.isOptionalCheckbox && this.validateCheckBox(jsonHeadings[this.state.issuerIndex], checkBoxIndex) && this.hideReturnToPDRCheckBox(dataColumn, this.props.acquirerCode)  && <TextField
                htmlFor="comment-box"
              >
                
                {(this.props.disputeStageId !== 1 || this.props.actionViewCode !== 'CC') && 
                  <Checkbox
                    key={dataColumnIndex}
                    checkBoxKey={checkBoxIndex}
                    label={dataColumn.description}
                    extraClass={dataColumn.extraClass}
                    id="activeRuleCheckBox"
                    isChecked={this.state.checkBoxStatus[checkBoxIndex]}
                    onChange={this.toggleCheckbox}
                    // disabled={(this.props.selectedOption && this.props.selectedOption[0] && this.props.selectedOption[0].value == 164 || this.props.selectedOption && this.props.selectedOption[0] && this.props.selectedOption[0].value == 165) && this.props.selectedOption[1] && this.props.selectedOption[1].value == 2700 ? true : false}
                    extraLabelStyle={{
                      color: `${COLORS.oneGp.black}`,
                      background: 'unset',
                      fontSize: 'larger',
                      paddingLeft: 14,
                      paddingTop: 3,
                      display: 'inline-flex',
                    }}
                  />
                }
              </TextField>
            }
            {
              dataColumn.displayType == __CHECKBOX__ && dataColumn.isOptionalCheckbox && isPartial && this.validateCheckBox(jsonHeadings[this.state.issuerIndex], checkBoxIndex) && this.hideReturnToPDRCheckBox(dataColumn, this.props.acquirerCode)  && <TextField
                htmlFor="comment-box"
              >
                {
                  <Checkbox
                    key={dataColumnIndex}
                    checkBoxKey={checkBoxIndex}
                    label={dataColumn.description}
                    extraClass={dataColumn.extraClass}
                    checkBoxId={dataColumn?.checkBoxId}
                    id="activeRuleCheckBox"
                    isChecked={this.state.checkBoxStatus[checkBoxIndex]}
                    onChange={this.toggleCheckbox}
                    extraLabelStyle={{
                      color: '#262aff',
                      background: 'unset',
                      fontSize: 'larger',
                      paddingLeft: 14,
                      paddingTop: 3,
                      display: 'inline-flex',
                    }}
                    disabled={disableFinancials}
                  />
                }
              </TextField>
            }
            {pageListArray !== undefined && pageListArray.length > 0 && pageListArray[this.state.selectedPage] !== undefined && this.state.visible && <ImageModal
              title={this.props.caseDocuments.documentNames[this.state.selectedPage]}
              visible={this.state.visible}
              okButtonProps={{ hidden: 'hidden' }}
              cancelButtonProps={{ hidden: 'hidden' }}
              onCancel={this.closeImageModal}
              width={1200}
              wrapClassName={this.modalWrapperClass}
              updateParentSelectedPages={this.updateSelectedPages}
              imageContents={this.props.caseDocuments[this.state.documentType]?.imageToolKitData ? this.props.caseDocuments[this.state.documentType].imageToolKitData[this.state.selectedPage] : this.props.caseDocuments.imageToolKitData[this.state.selectedPage]}
              imageContentsErr={this.state.imageContentsErr}
              updateFlag
              updatePageSelectionIndex={this.selectImagePage}
              canvasSelectedIndex={this.state.canvasSelectedIndex[this.state.selectedPage] == undefined || (this.state.canvasSelectedIndex[this.state.selectedPage] !== undefined && pageListArray[this.state.selectedPage].length - 1 < this.state.canvasSelectedIndex[this.state.selectedPage]) ? 0 : this.state.canvasSelectedIndex[this.state.selectedPage]}
              selectedPages={this.props.caseDocuments[this.state.documentType].selectedPages[this.state.selectedPage]}
              selectAllFlag={this.props.caseDocuments[this.state.documentType].selectAllFlag[this.state.selectedPage]}
              zoomStyle={{ paddingLeft: 570 }}
              updatePageList={this.updatePageListArray}
              caseNumber={this.props.caseNumber}
              documentTypeNames={this.props.caseDocuments.documentTypeNames[this.state.selectedPage]}
              pageList={pageListArray[this.state.selectedPage]}
              acquirerCode={this.props.acquirerCode}
            />}
            { this.props.actionViewCode === "RTI" && this.props.cardBrandCode == "VI" && this.props.disputeStageName === "Incoming Pre-Arbitration" ?
             dataColumn.displayType == __NESTED_FIELD_SELECTOR__ && <NestedFieldSelector
             title={dataColumn.title}
             list={this.props[dataColumn.identifier]}
             size={dataColumn.size}
             inputType={dataColumn.inputType}
             inputList={dataColumn.inputList}
             identifier={dataColumn.identifier}
             bindData={this.props[dataColumn.bindWith]}
             prePopulatedData={this.props.adjustmentLedger}
             disputeAmount={this.state.disputeAmount}
             storeLatestStatus={this.storeLatestStatus}
             onDisableNextStep={this.props.onDisableNextStep}
             totalIdCount={this.state.totalIdCount}
              />
              :
            dataColumn.displayType == __NESTED_FIELD_SELECTOR__ && <NestedFieldSelector
             title={dataColumn.title}
             list={this.props[dataColumn.identifier]}
             size={dataColumn.size}
             inputType={dataColumn.inputType}
             inputList={dataColumn.inputList}
             identifier={dataColumn.identifier}
             bindData={this.props[dataColumn.bindWith]}
             prePopulatedData={this.props.adjustmentLedger}
             />
            }
            {
              dataColumn.displayType == __DISPLAY_PANEL__ && <DisplayPanel
                structure={dataColumn.structure}
                data={this.props[dataColumn.identifier]}
                balanceAmount={{ amount: this.props.balanceAmount }}
                size={dataColumn.size}
                marginLeft={dataColumn.marginLeft}
                customClass={dataColumn.customClass}
              />
            }
            {
              dataColumn.displayType == __REVIEW_SCREEN__ && <ReviewScreen
                disputeStageName={this.props.disputeStageName}
                dataColumn={dataColumn}
                visaQnReviewData={this.props.visaQnReviewData}
                cardBrand={this.props.cardBrand}
                buttonClick={this.props.buttonClick}
                pageList={this.state.pageList}
                jsonHeadings={jsonHeadings}
                selectedAccordianIndex={this.state.selectedAccordianIndex}
                toggleThisAccordion={this.toggleThisAccordion}
                isopen={wizardStatus && wizardStatus.status ? true : false}
                updatePageSelectionIndex={this.state.canvasSelectedIndex}
                updatePageSelectionIndexMethod={this.openSelectedPageInModal}
                issuerIndex={this.props.issuerIndex}
                dataColumnIndex={reviewPageDisplayIndex}
                getAdjustFinancialDataForReview={this.props.getAdjustFinancialDataForReview}
                getReviewPageDescription={this.props.getReviewPageDescription}
                getMerchantImageData={this.props.getMerchantImageData}
                issuerActionData={this.props.issuerActionData}
                issuerSelectedPages={this.props.caseDocuments.issuerImageData.orderOfSelectedPages}
                merchantSelectedPages={this.props.caseDocuments.merchantImageData.orderOfSelectedPages}
                merchantMessageTemp={this.props.merchantMessageTemp.filter(item => item?.desc != "Choose One" && item?.desc != null && item?.title != null)}
                actionViewCode={this.props.actionViewCode}
                extraLabelStyle={{
                  color: 'gray',
                  background: 'unset',
                  fontSize: 'larger',
                  paddingLeft: 14,
                  paddingTop: 3,
                  display: 'inline-flex',
                  fontColor: 'gray',
                }}
                getLiabilityData={this.props.getLiabilityData}
                reasonCodeCategoryDesc={this.props.reasonCodeCategoryDesc}
                representmentAmount={this.state.representmentAmount}
                acquirerCode={this.props.acquirerCode}
              />}
            <div style={{ width: dataColumn.width }}>
              {dataColumn.displayType == __DAYS_LEFT_CALENDAR__ && <DaysLeftCalendar
                handleSingleDateChange={this.props.handleSingleDateChange}
                prePopulateDate={this.props.prePopulateDate}
                pendDate={this.props.pendDate}
                daysLeft={this.props.daysLeft}
                todayDate={this.props.todayDate}
                labelDescription={dataColumn.name}
                dateFormat={this.props.dateFormat}
                cardBrandDueDate={this.props.cardBrandDueDate}
              />}</div>

            {dataColumn.displayType == __MERCHANT_MESSAGE__ &&
              <MerchantMessage
                merchantNumber={this.props.merchantNumber}
                fetchEnglishMessageData={this.props.fetchEnglishMessageData}
                fetchOtherMessageData={this.props.fetchOtherMessageData}
                fetchPredefMessageData={this.props.fetchPredefMessageData}
                fetchLangId={this.props.fetchLangId}
                caseStageId={this.props.caseStageId}
                onDisableNextStep={this.props.onDisableNextStep}
                englishMessage={this.props.englishMessage}
                otherMessage={this.props.otherMessage}
                predefMessage={this.props.predefMessage}
                letterTemplate={this.props.letterTemplate}
                fetchMessageType={this.props.fetchMessageType}
                messageType={this.props.messageType}
                selectedActionIssuerId={this.state.selectedActionIssuerId}
                checkErrorFlag={this.props.checkErrorFlag}
                predefMessages={this.props.predefMessages}
                languageIndCode={this.props.languageIndCode}
                languageText={this.props.languageText}
                letterTemplates={this.props.letterTemplates}
                selections={this.props.selections}
                isMerchantMessageError={this.props.isMerchantMessageError}
                userPermissions={this.props.userPermissions}
                skipNotifyMerchant={this.props.jsonHeadings[this.state.issuerIndex].reviewScreenKey == "merchantMessage" ? this.props?.skipNotifyMerchantState: false}
              />
            }
            {dataColumn.displayType == __AUTO_COMPLETE_DROPDOWN_COMBO__ &&
              <AutoCompleteDropdown
                handleDropdownSelection={this.onSelectionChange}
                handleSearchDropdownSelection={this.handleSearchDropdownSelection}
                selectedDropdownValue={this.state.selectedInput ? this.state.selectedInput[0] : null}
                selectedSearchDropdown={this.state.selectedSearchOption}
                searchDropDownList={this.props.transferUserList}
                selectInputDropdownList={this.state.secondaryOptions}
                selectInputLabel={dataColumn.selectInputLabel}
                searchDropdownLabel={dataColumn.searchDropdownLabel}
                isSelectInputRequired={true}
                selectInputWidth={dataColumn.width}
              />}
            {
              dataColumn.displayType == __VISA_QUESTIONNAIRE__ &&
              <Questionnaire
                disputeType={this.props.reasonCodeCategoryDesc}
                cardBrand={this.props.cardBrand}
                reasonCode={this.props.reasonCode}
                docInd={this.props.supportDocumentInd}
                issuerIndex={this.props.issuerIndex}
                isDocChecked={this.state.checkBoxStatus[0]}
                attachDocumentPage={this.props.attachDocumentPage}
                onDisableNextStep={this.props.onDisableNextStep}
                setQuestionnaireData={this.props.setQuestionnaireData}
                dataColumns={this.props.questionDataColumns}
                levelOneInitialQuesDataColumns={this.props.levelOneInitialQuesDataColumns}
                prevLevelThreeQuesDataColumns={this.props.prevLevelThreeQuesDataColumns}
                attachArrayQuesColumns={this.props.attachArrayQuesColumns}
                levelTwoComponents={this.props.levelTwoComponents}
                levelThreeComponents={this.props.levelThreeComponents}
                levelOneComponents={this.props.levelOneComponents}
                reasonCodeCategory={this.props.reasonCodeCategory}
                setQuestionnaireReviewData={this.props.setQuestionnaireReviewData}
                setVisaQuestionnaireSubmitData={this.props.setVisaQuestionnaireSubmitData}
                issuerActionData={this.props.issuerActionData}
                merchantRegionCode={this.props.merchantRegionCode}
                merchantCurrencyCode={this.props.merchantCurrencyCode}
                foreignDomesticIndicator={this.props.foreignDomesticIndicator}
              />
            }
            {
              dataColumn.displayType == __UPLOAD_DOCUMENT__ && <UploadDocuments
                fileUploaded={this.props.fileUploaded}
                uploadFileList={this.props.uploadFileList}
                isDisabledHandler={this.props.isDisabledHandler}
                updateNextButtonStatus={this.props.updateNextButtonStatus}
                acquirerCode={this.props.acquirerCode}
              />
            }
            {dataColumn.displayType == __MSGBOX__ && this.isVisible(dataColumn) &&
              <TextField
                htmlFor="comment-box"
              >
                <Checkbox
                  checkBoxKey={checkBoxIndex}
                  label={dataColumn.description}
                  extraClass={dataColumn.extraClass}
                  id="activeRuleCheckBox"
                  isChecked={this.state.isFinancialLossOccured}
                  onChange={this.acceptFinancialLoss}
                  extraLabelStyle={{
                    color: '#000000',
                    background: 'unset',
                    fontSize: 'larger',
                    paddingLeft: 14,
                    paddingTop: 3,
                    display: 'inline-flex',
                  }}
                />
              </TextField>
            }
            {

              dataColumn.displayType == __DATE__ && this.isVisible(dataColumn) && <div style={{
                width: dataColumn.width, marginTop: dataColumn.marginTop ? dataColumn.marginTop : 0,
                marginLeft: dataColumn.marginLeft ? dataColumn.marginLeft : 0,
              }} id={dateIndex}>
                <SingleDateInput
                  id={dateIndex}
                  name={dataColumn.name}
                  singleDate={!isEmpty(this.props.date) && this.props.date[dateKey] ? this.props.date[dateKey] : undefined}
                  onApply={this.handleSingleDateChange}
                  title={dataColumn.name}
                  minDate={moment().subtract(10, 'years')}
                  //  maxDate={moment()} /*Removing for Issue 411 - Pursue Case Filing */
                  dateFormat={dataColumn.dateFormat}
                /></div>
            }
          </div>
        );
      }
    });
  }

  render() {
    return (
      <div style={{ minHeight: 229 }}>
        {this.showDateLimitExceedBanner()}
        {this.formControlGroup()}
      </div>
    );
  }
}
ActionIssuerComponents.propTypes = {
  jsonHeadings: PropTypes.array,
  buttonClick: PropTypes.func,
  acquirerCode: PropTypes.string,
  merchantRegionCode: PropTypes.string,
  merchantNumber: PropTypes.string.isRequired,
  getAdjustFinancialDataForReview: PropTypes.func,
  checkErrorFlag: PropTypes.func,
  adjustmentLedger: PropTypes.array,
  balanceAmount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  isMerchantMessageError: PropTypes.bool,
  userPermissions: PropTypes.object,
  date: PropTypes.object,
  inputText: PropTypes.object,
  caseDocuments: PropTypes.object,
  updateSelectedCaseDocuments: PropTypes.func,
  setQuestionnaireReviewData: PropTypes.func,
  visaQnReviewData: PropTypes.array,
  cardBrandDueDate: PropTypes.string
};

ActionIssuerComponents.defaultProps = {
  jsonHeadings: [],
  buttonClick: () => { },
  getAdjustFinancialDataForReview: () => { },
  checkErrorFlag: () => { },
  userPermissions: {},
  date: {},
  inputText: {},
  caseDocuments: {},
  updateSelectedCaseDocuments: () => {},
  setQuestionnaireReviewData: () => {},
  visaQnReviewData: [],
  cardBrandDueDate: "01/01/2199"
};

export default ActionIssuerComponents;